// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1GQk_","label":"Radio_label__yjKpm","checkMark":"Radio_checkMark__6n4p1","disabled":"Radio_disabled__2q9AA"};